export default "__VITE_ASSET___je4Mwr0__"